export default __webpack_public_path__ + "static/summer_containers79-26dca8c82649b4a0ab7fd38bfbffd2df.webp";